export default __webpack_public_path__ + "static/headerBackground-5e17dcf63660450fbd5539cafadb62bd.png";